import { render, staticRenderFns } from "./WorkEntails.vue?vue&type=template&id=6b3905b2"
import script from "./WorkEntails.vue?vue&type=script&lang=js"
export * from "./WorkEntails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports